import PropTypes from 'prop-types';
import Text from '../../Text';

import commonAuthCss from '../auth.module.scss';

const GeneralNotices = ({ failAuthNotice, successAuthNotice }) => (
  <div data-testid="authGeneralNotices">
    {failAuthNotice && (
      <div className={commonAuthCss.largeSection}>
        <div className="row">
          <div className="col-xs-12">
            <p data-testid="failAuthNotice" className={commonAuthCss.errorText}>
              <Text name={failAuthNotice} />
            </p>
          </div>
        </div>
      </div>
    )}
    {successAuthNotice && (
      <div className={commonAuthCss.largeSection}>
        <div className="row">
          <div className="col-xs-12">
            <p
              data-testid="successAuthNotice"
              className={commonAuthCss.successText}
            >
              <Text name={successAuthNotice} />
            </p>
          </div>
        </div>
      </div>
    )}
  </div>
);

GeneralNotices.propTypes = {
  failAuthNotice: PropTypes.string,
  successAuthNotice: PropTypes.string,
};

export default GeneralNotices;
